import { useEffect, useState } from "react";

import {
  defaultAnamneseConfig,
  ensureAnamneseConfig,
  hasV2Audience,
  isAnamneseV2,
  isVersionV2,
  readStoredAnamneseConfig,
} from "../utils/anamneseVersion";

export default function useAnamneseVersion() {
  const [config, setConfig] = useState(() => readStoredAnamneseConfig() || defaultAnamneseConfig());
  const [ready, setReady] = useState(() => Boolean(readStoredAnamneseConfig()));

  useEffect(() => {
    let cancelled = false;
    ensureAnamneseConfig().then((next) => {
      if (cancelled) return;
      setConfig(next);
      setReady(true);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return {
    ready,
    config,
    isV2: isAnamneseV2(config),
    isKidsV2: hasV2Audience("kids", config),
    isBabyV2: hasV2Audience("baby", config),
    isCollectionV2: isVersionV2(config),
    version: config.version,
  };
}
